module.exports = __webpack_public_path__ + "media/images/footer_page/about/about-step3-3205a151a549801fae58fae7fb70efdd.svg";